<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="part-1-life">
<div class="section level2" id="back-in-burwood">
<h2>2. Back in Burwood</h2>
<p style="text-indent:0em;">When I was eight, I put rocks on railway tracks</p>
<p style="text-indent:0em;">near the Strathfield – Burwood overpass. Once,</p>
<p style="text-indent:0em;">a train shot fiercely from the dark</p>
<p style="text-indent:0em;">and dragged at me</p>
<p style="text-indent:0em;">and screamed at me</p>
<p style="text-indent:0em;">but I hugged the bank</p>
<p style="text-indent:0em;">and in the re-emerged and gentle black</p>
<p style="text-indent:0em;">I laughed till the tingling stopped.</p>
<br/>
<p style="text-indent:0em;">I lived on Mount Pleasant Avenue, a poorly named street.</p>
<p style="text-indent:0em;">My father drank two bottles of sweet sherry each night.</p>
<p style="text-indent:0em;">We shared a veranda, but slipping out was easy,</p>
<p style="text-indent:0em;">past the dunny and the veggies, over the palings into</p>
<p style="text-indent:0em;">comfortably furtive streets.</p>
<p style="text-indent:0em;">I’d meet Chris or Des and tease fires in backyards,</p>
<p style="text-indent:0em;">burn leaves, fences, and once the side of a house.</p>
<br/>
<p style="text-indent:0em;">I grew up with greyhounds in the backyard,</p>
<p style="text-indent:0em;">nestling on odd nights with the bitch and suckling pups</p>
<p style="text-indent:0em;">in a warm, rich-smelling incubus, away from</p>
<p style="text-indent:0em;">sherry and tobacco.</p>
<p style="text-indent:0em;">Outside the house, it was hunting time.</p>
<p style="text-indent:0em;">At ten, I hunted for midnight cars with half-bricks.</p>
<p style="text-indent:0em;">One night the police came, and I was charged.</p>
<p style="text-indent:0em;">One knew my father. In court, they did a deal,</p>
<p style="text-indent:0em;">so at Burwood Police Boys Club, I learned to somersault,</p>
<p style="text-indent:0em;">climb ropes, and box.</p>
<p style="text-indent:0em;">And hitting was good and hitting hard, even being hit</p>
<p style="text-indent:0em;">had a special sweetness, and I dreamed of fighting</p>
<p style="text-indent:0em;">Carruthers or Olsen with proper gloves, not</p>
<p style="text-indent:0em;">oversized pillows on stick arms.</p>
<br/>
<p style="text-indent:0em;">At twelve, in a brick pit near Croydon, I slid</p>
<p style="text-indent:0em;">down the scree to the edge of the drop –</p>
<p style="text-indent:0em;">In the shifting, dancing moonlight</p>
<p style="text-indent:0em;">the pit bottom moved and scurried viciously</p>
<p style="text-indent:0em;">into corners and scrabbled up at me and</p>
<p style="text-indent:0em;">my only hand-hold was grass that moved as I pulled,</p>
<p style="text-indent:0em;">and gravel pattered down, a skeletal noise,</p>
<p style="text-indent:0em;">a death rattle sound.</p>
<p style="text-indent:0em;">It took a long time to reach the top.</p>
<p style="text-indent:0em;">When I did, I looked back down –</p>
<p style="text-indent:0em;">It was only a brick pit.</p>
<p style="text-indent:0em;">I hugged the ground and laughed.</p>
<p style="text-indent:0em;">Chris died not long afterward of leukaemia,</p>
<p style="text-indent:0em;">a praying mantis kid who disappeared</p>
<p style="text-indent:0em;">after a party one night.</p>
<p style="text-indent:0em;">Des died of head injuries from falling bricks</p>
<p style="text-indent:0em;">on a building site.</p>
<p style="text-indent:0em;">I said I wasn’t there.</p>
<br/>
<p style="text-indent:0em;">So, in mad and casual ways, I grew up.</p>
<p style="text-indent:0em;">Two marriages later,</p>
<p style="text-indent:0em;">I’m back in Burwood and I see</p>
<p style="text-indent:0em;">my youth in streets much smaller than they were,</p>
<p style="text-indent:0em;">and names of ghostly friends</p>
<p style="text-indent:0em;">on honour rolls of clubs.</p>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Section0002.vue?24c5cbbf